// Shapes returned by the public booking page API (see BookingPagePresenter).

export type PhotoLayout = 'none' | 'cover' | 'gallery';
export type DayKey = 'mon' | 'tue' | 'wed' | 'thu' | 'fri' | 'sat' | 'sun';

export interface BookingPagePhoto {
  id: string;
  alt: string | null;
  position: number;
  thumb_url: string | null;
  large_url: string | null;
}

export interface BookingPageTeamMember {
  id: number;
  public_id: string;
  name: string;
  specialization: string | null;
  bio: string | null;
}

export interface TimeRange {
  from: string;
  to: string;
}

export interface OpeningHours {
  days: { day: DayKey; ranges: TimeRange[] }[];
  open_now: boolean;
  closes_at: string | null;
}

export interface BookingPageLocation {
  address: string;
  latitude: number | null;
  longitude: number | null;
  directions_url: string | null;
}

export interface BookingPageBlock {
  tagline: string | null;
  layout: PhotoLayout;
  photos: BookingPagePhoto[];
  show_team: boolean;
  team: BookingPageTeamMember[];
  about: string | null;
  show_online: boolean;
  phone: string | null;
  email: string | null;
  hours: OpeningHours | null;
  location: BookingPageLocation | null;
  // Hours before the start a customer can still cancel online; null when
  // online cancelling is off.
  cancellation_hours?: number | null;
}

export interface PublicOrganization {
  id: number;
  name: string;
  subdomain: string;
  email?: string;
  phone: string | null;
  address: string | null;
  business_type?: string;
  logo_url?: string | null;
  homepage_url?: string | null;
  public_locales?: string[];
  description?: string | null;
  timezone: string;
  currency?: string;
  booking_page: BookingPageBlock;
}

export interface PublicService {
  id: number;
  public_id: string;
  name: string;
  description?: string | null;
  duration_minutes: number;
  price: number;
  formatted_price?: string;
  hide_price?: boolean;
  max_capacity: number;
  group_booking?: boolean;
  active: boolean;
}

// Display options: the embed can hide the Sloty header, the photos and the
// sidebar. The public page shows everything.
export interface ProfileDisplayOptions {
  header: boolean;
  photos: boolean;
  sidebar: boolean;
  embedded: boolean;
}

export const FULL_PAGE: ProfileDisplayOptions = { header: true, photos: true, sidebar: true, embedded: false };
